import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationDE from './locales/de/translation.json';
import translationEN from './locales/en/translation.json';

const resources = {
  de: { translation: translationDE },
  en: { translation: translationEN }
};

i18n
  .use(LanguageDetector) // <--- wichtig!
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    interpolation: { escapeValue: false },
    detection: {
      // Reihenfolge der Detection:
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      // Wie die Sprache gespeichert werden soll:
      caches: ['localStorage'],
    }
  });

export default i18n;
